import Hero from '@components/Hero';
import Info from '@components/Info';
import Container from '@components/UI/Container';
import Icon from '@components/UI/Icon';
import Link from '@components/UI/Link';
import Picture from '@components/UI/Picture';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';
import Card from '@components/Card';
import Grid from '@components/Grid';
import HomeData from '@screens/Home/data';

import css from '@utils/css';

import Data from './data';

import React from 'react';

const PageHero = () => {

    const { features } = Data;

    return (
        <Hero
            mods={{ home: true }}
        >
            <Container>
                <Info
                    mods={{ center: true }}
                    className={css('max-w-[996px] mx-auto')}
                >
                    <Heading
                        tag='h1'
                    >
                        Traqq <span className={'text-violet-700'}>Scientific Collaboration</span> Program
                    </Heading>

                    <Paragraph
                        tag='p'
                        size='lg'
                        className={css('!leading-32p max-w-[840px]')}
                    >
                        Traqq welcomes the opportunity to engage in scientific research projects and offer academic and research institutions diverse workforce tracking data solutions. Through our innovative tools, we aim to support institutions in analyzing work patterns and productivity, ultimately contributing valuable insights to the field of human behavior.
                    </Paragraph>
                </Info>
                <Grid
                    xs={1}
                    mods = {{
                        shadow: true
                    }}
                    className={'p-6 mt-12 rounded-16p'}
                >
                    <Grid
                        xs={2}
                        lg={4}
                        gx={6}
                        gy={10}
                        mods = {{
                            bordered: true
                        }}
                    >
                        {features.map(item => (
                            <div
                                key={ item.id }
                                className={'flex flex-col gap-4'}
                            >
                                <div className={'bg-violet-100 rounded-lg w-12 h-12 flex items-center justify-center'}>
                                    {item.icon?.name && <Icon
                                        name={ item.icon?.name }
                                        color={ 'violet-700' }
                                        size={ 24 }
                                    />}
                                </div>
                                <h3
                                    className='heading h7'
                                >
                                    {item.title}
                                </h3>
                            </div>
                        ))}
                    </Grid>
                </Grid>
            </Container>
        </Hero>
    );
}

export default PageHero;
